import React from 'react';
var CIRCLE_HEIGHT = 8;
var LINE_HEIGHT = 2;
export default function HorizontalDragLine() {
  return React.createElement("div", {
    className: "position-absolute width-full flexbox flexbox-align-center zindex-small",
    style: {
      lineHeight: 0,
      left: -1 * CIRCLE_HEIGHT,
      top: -4
    }
  }, React.createElement("div", {
    style: {
      height: CIRCLE_HEIGHT,
      width: CIRCLE_HEIGHT
    },
    className: "border-medium border-primary radius-round"
  }), React.createElement("div", {
    style: {
      height: LINE_HEIGHT,
      flex: '1 1 auto',
      borderBottomRightRadius: 2,
      borderTopRightRadius: 2
    },
    className: "background-primary"
  }));
}